export default "__VITE_ASSET__7ececce0__"